// ./hooks/ui.filteredMenu.hook.ts
// $ui hooks

import { mdiFileDocument, mdiShield, mdiCellphone } from "@mdi/js";

export function getFilteredMenu(
  context: Record<string, any>,
  menus: Array<Record<string, any>>,
): Array<Record<string, any>> {
  let filteredMenu: Array<Record<string, any>> = [];

  (function handleFilteredMenu(): void {
    filteredMenu = (menus || []).reduce(
      (filtered: Array<Record<string, any>>, menuItem) => {
        // generate product (gadget, hotel, etc)
        // product category listing (dynamic from BE)
        // --> when isProductCategory: true
        if (menuItem.isProductCategory) {
          const { organization } =
            context.app.store.getters["auth/getUserData"];
          let { productCategories = [] as Array<Record<string, any>> } =
            organization;

          // temp solution for hide menu on sidebar
          const hiddenMenus = ["Travel", "Finance", "Hotel", "Logistic", "Vehicle", "Goods"];

          productCategories = productCategories.filter(
            (item) => !hiddenMenus.includes(item.name),
          );

          // filter out duplicate EB
          if (!context.app.$role.isQoalaSuperAdmin()) {
            productCategories = productCategories.filter(
              (item: Record<string, any> = {}) =>
                item.name != "Employee Benefit",
            );
          }

          const tempDyanmicCategories: Array<Record<string, any>> = [];
          productCategories.forEach((item: Record<string, any> = {}) => {
            // child menu of each product
            const productItems = [
              // policy list
              {
                permission:
                  context.app.$permission.checkPermissionPolicyListPage(
                    item.slug,
                  ),
                items: {
                  text: "Policy List",
                  name: "policy",
                  icon: mdiFileDocument,
                },
              },
              // claim list
              {
                permission:
                  context.app.$permission.checkPermissionClaimListPage(
                    item.slug,
                  ),
                items: {
                  text: "Claim List",
                  name: "claim",
                  icon: mdiShield,
                },
              },
              // gadget list
              {
                permission:
                  item.name === "Gadget" &&
                  context.app.$permission.permissionGadgetListPage(),
                items: {
                  text: "Gadget List",
                  name: "list",
                  icon: item?.icon ?? mdiCellphone,
                },
              },
            ];
            // filter & map --> user reduce
            // https://stackoverflow.com/questions/34398279/map-and-filter-an-array-at-the-same-time
            const items = productItems.reduce(
              (productMenuFiltered: Record<string, any>, productItem) => {
                if (productItem.permission) {
                  productMenuFiltered.push(productItem.items);
                }

                return productMenuFiltered;
              },
              [],
            );

            const obj = Object.assign(
              {},
              {
                text: item.name,
                name: item.slug,
                icon: item.icon,
                group: item.slug,
                items,
              },
            );
            tempDyanmicCategories.push(obj);
          });
          // add dynamic product category to menu
          // add when it has sub menu
          filtered = filtered.concat(
            tempDyanmicCategories.filter(
              (productMenu) => productMenu.items.length,
            ),
          );
        } else {
          // menu stated in js
          const pathWithChild = context.app.localePath(`/${menuItem.group}`);
          const pathWithoutChild = context.app.localePath(`/${menuItem.name}`);
          const hasChildMenu = menuItem.items && menuItem.items.length > 0;

          let path = pathWithoutChild;
          // has sub (child menu)
          if (hasChildMenu) {
            path = pathWithChild;
          }
          const menuItemPermissionAdjustment: Array<Record<string, any>> =
            context.app.$permission.permissionSidebarRoutingChecker(path, true);

          // has sub (child) menu
          if (hasChildMenu) {
            // revise the child menu based on permission
            // get the sub menu
            const subMenu = menuItemPermissionAdjustment.reduce(
              (
                modified: Array<Record<string, any>>,
                currentItem: Record<string, any>,
              ) => {
                if (currentItem.page) {
                  return (currentItem.child || []).reduce(
                    (
                      modifiedChild: Array<Record<string, any>>,
                      currentChildItem: Record<string, any>,
                    ) => {
                      if (
                        currentChildItem.page &&
                        currentChildItem.permission
                      ) {
                        return [
                          ...modifiedChild,
                          menuItem.items.find(
                            (searchedItem: Record<string, any> = {}) =>
                              searchedItem.name === currentChildItem.name,
                          ),
                        ];
                      }
                      return modifiedChild;
                    },
                    [],
                  );
                }
                return modified;
              },
              [],
            );

            // item to be pushed
            const filteredMenuItem = {
              ...menuItem,
              items: subMenu,
            };
            // push if have child menu
            if (subMenu.length > 0) {
              filtered.push(filteredMenuItem);
            }
          } else {
            // check menu has sub menu or not
            const doesMenuHavePermission =
              (
                menuItemPermissionAdjustment.filter(
                  (item) => item.page && item.permission,
                ) || []
              ).length > 0;

            // menu has permission
            // OR
            // menu is customise navigation --> must be always shown
            if (
              doesMenuHavePermission ||
              menuItem.action === "customiseNavigation"
            ) {
              filtered.push(menuItem);
            }
          }
        }

        return filtered;
      },
      [],
    );
  })();

  return filteredMenu;
}
